// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"680":"a717720f","724":"ae7c025a"}[chunkId] + ".chunk.js";
};